{
  "version": 1,
  "asset_id": "8b2e9383-f73d-46b0-929b-79c0ae6f662f",
  "project_id": "bc28ec3a-38d3-4a78-848c-5618f322d6de",
  "url": "/__l5e/assets-v1/8b2e9383-f73d-46b0-929b-79c0ae6f662f/timothy-ng-144.webp",
  "r2_key": "a/v1/bc28ec3a-38d3-4a78-848c-5618f322d6de/8b2e9383-f73d-46b0-929b-79c0ae6f662f/timothy-ng-144.webp",
  "original_filename": "timothy-ng-144.webp",
  "size": 4140,
  "content_type": "image/webp",
  "created_at": "2026-07-29T18:51:32Z"
}
